import { Box, Button, Card, Grid, IconButton, InputAdornment, TextField, Tooltip, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { NotificationServices } from './NotificationServices';
import Loading from '../../../components/Loader/Loading';
import { DataGrid } from '@mui/x-data-grid';
import CustomPagination from '../../../components/pagination/CustomPagination';
import { formatDateTime } from '../../../utils/dateUtils';
import { Edit, RemoveRedEye, RestartAlt, Search } from '@mui/icons-material';
import { PermissionGuard } from '../../../components/PermissionGuard';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import MultiColumnFilter from '../../../components/Filter/MultiColumnFilter';
import { Controller, useForm } from 'react-hook-form';

const CampaignList = () => {
  const navigate = useNavigate();
  // State to store the total row count inititally before server respond
  const [rowCount, setRowCount] = useState(5);

  // State to store the row count used by the DataGrid
  const [rowCountState, setRowCountState] = useState(rowCount);

  // Update rowCountState whenever rowCount changes
  useEffect(() => {
    setRowCountState((prevRowCountState) =>
      rowCount !== undefined ? rowCount : prevRowCountState,
    );
  }, [rowCount, setRowCountState]);

  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 5,
    filters: {
      searchKey: "",
      sortKey: 'updatedAt',
      sortDirection: 'desc',
      filterOptions: []
    }
  });

  const handlePaginationModel = (newPagination) => {
    setPaginationModel({
      ...paginationModel,
      page: newPagination.page,
      pageSize: newPagination.pageSize
    });
  }
  /******************* Sorting model  ******************************/
  const [sortModel, setSortModel] = useState([
    {
      field: paginationModel.filters.sortKey,
      sort: paginationModel.filters.sortDirection,
    },
  ]);

  const handleSortingChange = (newSortModel) => {
    console.log("new sort model", newSortModel);
    if (newSortModel && newSortModel.length > 0) {
      setSortModel(newSortModel);
      setPaginationModel(prev => ({
        ...prev,
        filters: {
          ...prev.filters,
          sortKey: newSortModel[0].field,
          sortDirection: newSortModel[0].sort
        }
      }));
    }
  }
  const cancelCampaign = async(campaignId)=>{
    const result =await Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, cancel it!'
    });
    if (result.isConfirmed) {
      // swal processing dialog
      Swal.fire({
        title: 'Processing...',
        text: 'Please wait while we cancel your campaign.',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      try {
        const response = await NotificationServices.cancelCampaign(campaignId);
        if (response.success === 1) {
          fetchNotificationList();
          await Swal.fire({
            icon: 'success',
            title: 'Success!',
            text: response.message || 'Your campaign has been cancelled.',
            timer: 1500
          });
        } else {
          await Swal.fire({
            icon: 'error',
            title: 'Error!',
            text: response.message
          });
        }
      } catch (error) {
        await Swal.fire({
          icon: 'error',
          title: 'Error!',
          text: 'Something went wrong.'
        });
        console.log('Something went wrong:',error);
      }
    }
  }
  const columns = [
    // { field: 'id', headerName: 'S.NO.', flex: 1 ,sortable:'false'},
    {
      field: 'description', headerName: 'Description', flex: 1.5, headerAlign: 'center',sortable:false,
      renderCell: (params) => (
        <Box sx={{ display: 'flex',width:'100%' ,flexDirection:'column',p:1,}}>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontSize:'0.65rem',width:'50%'}}>Mode</Typography>
            <Typography sx={{fontSize:'0.65rem',width:'2%',mx:1}}>:</Typography>
            <Typography sx={{fontSize:'0.65rem',textTransform:'capitalize'}}>{params.row.deliveryModes[0]}</Typography>
          </Box>
          {params.row.deliveryModes[0] === 'whatsapp' &&
            <Box sx={{display:'flex',flexDirection:'column',width:'100%'}}>
              {
                params.row?.whatsappData?.messageType == 'template' &&
                <>
                  <Box sx={{display:'flex'}}>
                    <Typography sx={{fontSize:'0.65rem',width:'50%'}}>Message Type</Typography>
                    <Typography sx={{fontSize:'0.65rem',width:'2%',mx:1}}>:</Typography>
                    <Typography sx={{fontSize:'0.65rem'}}>{params.row?.whatsappData?.messageType}</Typography>
                  </Box>
                  <Box sx={{display:'flex'}}>
                    <Typography sx={{fontSize:'0.65rem',width:'50%'}}>Template Name</Typography>
                    <Typography sx={{fontSize:'0.65rem',width:'2%',mx:1}}>:</Typography>
                    <Typography sx={{fontSize:'0.65rem'}}>{params.row?.whatsappData?.templateName}</Typography>
                  </Box>
                </>
              }
              {
                params.row?.whatsappData?.messageType == 'media' &&
                <>
                  <Box sx={{display:'flex'}}>
                    <Typography sx={{fontSize:'0.65rem',width:'50%'}}>Message Type</Typography>
                    <Typography sx={{fontSize:'0.65rem',width:'2%',mx:1}}>:</Typography>
                    <Typography sx={{fontSize:'0.65rem'}}>{params.row?.whatsappData?.messageType}</Typography>
                  </Box>
                  <Box sx={{display:'flex'}}>
                    <Typography sx={{fontSize:'0.65rem',width:'50%'}}>Media Type</Typography>
                    <Typography sx={{fontSize:'0.65rem',width:'2%',mx:1}}>:</Typography>
                    <Typography sx={{fontSize:'0.65rem'}}>{params.row?.whatsappData?.mediaType}</Typography>
                  </Box>
                  <Box sx={{display:'flex'}}>
                    <Typography sx={{fontSize:'0.65rem',width:'50%',textTransform:'capitalize'}}>{params.row?.whatsappData?.mediaType}</Typography>
                    <Typography sx={{fontSize:'0.65rem',width:'2%',mx:1}}>:</Typography>
                    {/* on click open image/pdf/doc in new tab */}
                    <Typography sx={{fontSize:'0.65rem',color:'blue',textDecoration:'underline',cursor:'pointer'}} onClick={()=>window.open(params.row?.whatsappData?.mediaUrl,'_blank')}>View</Typography>
                  </Box>
                </>
              }
              {
                params.row?.whatsappData?.messageType == 'text' &&
                <>
                  <Box sx={{display:'flex'}}>
                    <Typography sx={{fontSize:'0.65rem',width:'50%'}}>Message Type</Typography>
                    <Typography sx={{fontSize:'0.65rem',width:'2%',mx:1}}>:</Typography>
                    <Typography sx={{fontSize:'0.65rem'}}>{params.row?.whatsappData?.messageType}</Typography>
                  </Box>
                  <Card variant="outlined" sx={{p:1,bg:'#f5f5f5'}}>
                    <Typography sx={{fontSize:'0.65rem',wordBreak:'break-word'}}>{params.row?.whatsappData?.message}</Typography>
                  </Card>
                </>
              }
            </Box>
          }
          {
            
          }
          {params.row.deliveryModes[0] === 'push' &&
            <Card variant="outlined" sx={{p:1,bg:'#f5f5f5'}}>
                    <Typography sx={{fontSize:'0.65rem',wordBreak:'break-word'}}>{params.row?.title}</Typography>
                  </Card>
          }
        </Box>
      ),
     },
    {
      field: 'scheduledDateTime',headerName: 'Scheduled At',flex:1,headerAlign:'center',
      renderCell: (params) => (
        <Typography variant="body2" sx={{width:'100%',textAlign:'center',fontSize:'0.6rem',color:'#000000de'}}>{params.row.updatedAt && formatDateTime(params.row.scheduledDateTime)}</Typography>
      ),
    },
    {
      field:'details',headerName: `Stats`,flex:1,headerAlign:'center',sortable:false,
      renderCell: (params) => (
        <Box sx={{display:'flex',flexDirection:'column',gap:1,p:1,width:'100%'}}>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontSize:'0.5rem',width:'50%'}}>Total Queued</Typography>
            <Typography sx={{fontSize:'0.5rem',width:'2%',mx:1}}>:</Typography>
            <Typography sx={{fontSize:'0.5rem'}}>{params.row.totalQueued}</Typography>
          </Box>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontSize:'0.5rem',width:'50%'}}>Total Sent</Typography>
            <Typography sx={{fontSize:'0.5rem',width:'2%',mx:1}}>:</Typography>
            <Typography sx={{fontSize:'0.5rem'}}>{params.row.totalSent}</Typography>
          </Box>
          <Box sx={{display:'flex'}}>
            <Typography sx={{fontSize:'0.5rem',width:'50%'}}>Total Failed</Typography>
            <Typography sx={{fontSize:'0.5rem',width:'2%',mx:1}}>:</Typography>
            <Typography sx={{fontSize:'0.5rem'}}>{params.row.totalFailed}</Typography>
          </Box>
        </Box>
      ),
    },
    {
      field: 'updatedAt',headerName: 'Sent On',flex:1,headerAlign:'center',
      renderCell: (params) => (
        <Typography variant="body2" sx={{width:'100%',textAlign:'center',fontSize:'0.6rem',color:'#000000de'}}>{params.row.updatedAt && formatDateTime(params.row.updatedAt)}</Typography>
      ),
    },
    {
      field: 'status',headerName: 'Status',flex:1,headerAlign:'center',
      renderCell: (params) => (
        <Typography variant="body2" sx={{width:'100%',textAlign:'center',fontSize:'0.6rem',color:'#000000de'}}>{params.row.status}</Typography>
      ),
    },
    {
      field: 'actions',
      headerName: 'Actions',
      headerAlign:'center',
      // flex: .5,
      filterable: false,
      sortable: false,
      renderCell: (params) => (
        <Box sx={{ p: 1, display: 'flex',flexDirection:'column',gap:1 ,justifyContent: 'center',alignItems:'center',width:'100%' }}>
          {/* <IconButton
            sx={{color: "blue",}}
            onClick={() => window.open(`/marketing/banner/view/${params.row.id}`, '_blank')} 
            size="small">
            <RemoveRedEye sx={{fontSize:'0.95rem'}}/>
          </IconButton> */}
          {/* <PermissionGuard feature='banner' permission='canEdit'> */}
            {/* <IconButton onClick={() => window.open(`/marketing/banner/${params.row.id}`,'_blank')} size="small" color='warning'>
              <Edit sx={{fontSize:'0.95rem'}}/>
            </IconButton> */}
          {/* </PermissionGuard> */}
          <PermissionGuard feature='notification' permission='canView'>
            <Button size='small' color='primary' variant='outlined' sx={{textTransform:"capitalize",fontSize:'.6rem',p:.25}} onClick={()=>window.open(`/notification/${params.row.notificationId}`,'_blank')}>
              View
            </Button>
          </PermissionGuard>
          {(params.row.status != 'CANCELLED' && params.row.status != 'COMPLETED' ) && <PermissionGuard feature='notification' permission='canEdit'>
            <Button size='small' color='error' variant='outlined' sx={{textTransform:"capitalize",fontSize:'.6rem',p:.25}} onClick={()=>cancelCampaign(params.row.notificationId)}>
              Cancel
            </Button>
          </PermissionGuard>}
        </Box>
      ),
    },
  ]
  const [notifications, setNotifications] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const fetchNotificationList = async () => {
    setIsloading(true);
    try {
      const notificationResponse = await NotificationServices.fetchNotification({
        page: paginationModel.page,
        limit: paginationModel.pageSize,
        filters: {
          searchKey: paginationModel.filters.searchKey,
          sortKey: paginationModel.filters.sortKey,
          sortDirection: paginationModel.filters.sortDirection,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      });
      if (notificationResponse.success == '1') {
        setNotifications(notificationResponse.data.notifications);
        setRowCount(notificationResponse.data.pagination.totalCount);
      } else if (notificationResponse.success == '0') {
        console.log("Error fetching Notifications:", notificationResponse.message);
      }
    } catch (error) {
      console.log("Error fetching Notifications:", error)
    } finally { setIsloading(false); }
  }
  useEffect(() => {
    fetchNotificationList();
  }, [paginationModel])

  const filterableColumns = [
    {
      key: 'title',
      label: 'Notification title',
      type: 'text'
    },
    {
      key: 'audienceType',
      label: 'Audeience Type',
      type: 'select',
      options: [
        { value: 'customer', label: 'Customer' },
        { value: 'expert', label: 'Service Expert' },
      ]
    },
    {
      key: 'status',
      label: 'Status',
      type: 'select',
      options: [
        { value: 'PENDING', label: 'Pending' },
        { value: 'QUEUED', label: 'Queued' },
        { value: 'PROCESSING', label: 'Processing' },
        { value: 'COMPLETED', label: 'Completed' },
        { value: 'FAILED', label: 'Failed' },
        { value: 'CANCELLED', label: 'Cancelled' },
        { value: 'PROCESSED', label: 'Processed' },
      ]
    },
    {
      key: 'isActive',
      label: 'Account',
      type: 'select',
      options: [
        { value: 'true', label: 'Active' },
        { value: 'false', label: 'Inactive' }
      ]
    },
    {
      key: 'isVerified',
      label: 'Is Verified',
      type: 'select',
      options: [
        { value: 'true', label: 'Verified' },
        { value: 'false', label: 'Not Verified' }
      ]
    },
    {
      key: 'scheduledDateTime',
      label: 'Scheduled Date',
      type: 'date'
    },
    {
      key: 'updatedAt',
      label: 'Sent Date',
      type: 'date'
    },
    // {
    //   key: 'isTester',
    //   label: 'Is Tester',
    //   type: 'select',
    //   options: [
    //     { value: 'true', label: 'True' },
    //     { value: 'false', label: 'False' }
    //   ]
    // }
  ];
  const handleApplyFilter = (filterData) => {
    // Process filter data
    console.log(filterData);
    setPaginationModel({
      ...paginationModel,
      page: 0, // Reset to first page when applying new filters
      filters: {
        ...paginationModel.filters,
        // Convert MultiColumnFilter options to a format your backend can understand
      filterOptions: filterData.filterOption.filter(filter => filter.fieldName && filter.value) // Remove empty filters
      }
    });
  }

  const { control, handleSubmit,getValues, reset } = useForm();
  /**** Advanced multi column filter related ****/
  const [clearMultiFilter, setClearMultiFilter] = useState(false);
  const clearFilters = () => {
      reset({
        searchKey: "",
      });
      setPaginationModel({
        ...paginationModel,
        filters: {
          ...paginationModel.filters,
          searchKey: "",
          sortBy: 'createdAt',
          sortType: 'desc',
          filterOptions: []
        }
      });
  
      // Trigger clear for MultiColumnFilter
      setClearMultiFilter(true);
  
      // Reset the clear trigger after a short delay
      setTimeout(() => setClearMultiFilter(false), 100);
  }
  function onSubmit(data) {
    const filtersData = getValues();
    setPaginationModel({
      ...paginationModel,
      filters: {
        ...paginationModel.filters,
        searchKey: filtersData.searchKey,
      }
    });
  }
  return (
    <Box>
      {/* <Box sx={{ p: '.5% 1%', border: '2px solid lightGray', bgcolor: 'lightGray' }}>
        <Typography sx={{ fontWeight: 600, fontSize: '0.85rem' }} >Sent Notifications</Typography>
      </Box> */}
      <Card>
        <Box sx={{ overflow: "auto" }}>
          <Box
            sx={{
              width: "100%", display: "table", tableLayout: "fixed",
              backgroundColor: "#fff", borderRadius: '.5rem',
              '& .odd': {
                bgcolor: 'white',
              },
              '& .even': {
                bgcolor: '#ECECEC',
              },
            }}>

            {isLoading && <Loading />}
            <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center', px: '1%' }}>
              <Box sx={{ display: 'flex', gap: 1 }}>
                <MultiColumnFilter
                  filterableColumns={filterableColumns}
                  onApplyFilter={handleApplyFilter}
                  externalClear={clearMultiFilter}
                  defaultFilterOptions={paginationModel.filters.filterOptions}
                />
                {/* <ExportAll paginationModel={paginationModel} columns={columns} statusOptions={statusOptions} /> */}
              </Box>
              <Box sx={{display:{xs:'none',sm:'block'}}}>
                {/* <QuickSearchTool filterModel={filterModel} setFilterModel={setFilterModel} /> */}
                <Grid container spacing={1} sx={{ p: '1%' }} component={'form'} onSubmit={handleSubmit(onSubmit)}>
                    <Grid item xs={9} lg={8}>
                      <Controller
                        name="searchKey"
                        control={control}
                        // defaultValue=""
                        render={({ field }) => (
                            <TextField
                            {...field}
                            placeholder="Search here....."
                            // label="Search"
                            size="small"
                            fullWidth
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                paddingLeft: '0px',
                                }
                            }}
                            InputProps={{  // Changed from slotProps to InputProps
                                inputProps: {
                                style: {
                                    height: '0.6rem',
                                    textTransform: 'uppercase',
                                    fontSize: 'x-small'
                                },
                                },
                                startAdornment: (
                                <InputAdornment position="start">
                                    <IconButton>
                                    <Search sx={{ fontSize: 'x-small' }} />
                                    </IconButton>
                                </InputAdornment>
                                ),
                            }}
                            />
                        )}
                        />
                    </Grid>
                    <Grid item xs={3} sm={4} >
                        <Tooltip title="Search" sx={{ ml: 1, p: 0 }}>
                        <IconButton
                            size='small'
                            color="primary"
                            type="submit"
                            sx={{ border: "1px solid", borderRadius: "7px", padding: "1%", ml: 1 }}
                        >
                            <Search sx={{ fontSize: '.85rem' }} />
                        </IconButton>
                        </Tooltip>
                        <Tooltip title="Clear All Filters">
                        <IconButton
                            size='small'
                            color="primary"
                            sx={{ marginLeft: "10px", border: "1px solid", color: "#f00", borderRadius: "7px", padding: "1%" }}
                            onClick={clearFilters}
                        >
                            <RestartAlt sx={{ fontSize: '.85rem' }} />
                        </IconButton>
                        </Tooltip>
                    </Grid>
                </Grid>
              </Box>
              {/* <Box>
                <TextField
                  value={quickFilterText}
                  onChange={(event) => setQuickFilterText(event.target.value)}
                  placeholder="Quick Search ..."
                  size="small"
                  fullWidth
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      paddingLeft: '0px',
                    }
                  }}
                  InputProps={{
                    inputProps: {
                      style: {
                        height: '0.6rem',
                        textTransform: 'uppercase',
                        fontSize: 'x-small'
                      },
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <IconButton>
                          <Search sx={{ fontSize: 'x-small' }} />
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Box> */}
            </Box>
            <DataGrid
              rows={notifications}
              columns={columns.map((col) => ({
                ...col,
                flex: col.flex || 1, // Ensure columns resize dynamically
                minWidth: col.minWidth || 150, // Set a minimum width to avoid overlap
              }))}
              getRowId={(row) => row._id}
              rowCount={rowCount}
              pageSizeOptions={[5, 10, 20, 50, 100]}
              paginationModel={paginationModel}
              paginationMode="server"
              onPaginationModelChange={handlePaginationModel}

              // Add these props for page numbers
              showFirstButton={true}
              showLastButton={true}

              // filterModel={filterModel}
              sortingMode="server"
              sortModel={sortModel}
              onSortModelChange={handleSortingChange}
              disableMultiSort={true}

              loading={isLoading}
              getRowClassName={(params) => {
                // console.log("checking customer is deleted",params.row.customer?.deletedAt)
                // Check if customer is deleted
                if (params.row.customer?.deletedAt) {
                  return 'deleted-row';
                }
                // Keep alternating row colors for non-deleted rows
                return params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
              }}

              disableColumnMenu
              disableRowSelectionOnClick
              // disableColumnFilter
              // disableColumnSelector
              disableDensitySelector
              sortingOrder={['asc', 'desc']}
              slots={{
                // toolbar: GridToolbar,
                loadingOverlay: Loading,
                // Optionally use custom pagination
                // pagination: CustomPagination,
              }}
              // slotProps={{
              //   toolbar: {
              //     showQuickFilter: true,  
              //   },
              // }}
              autoHeight
              getRowHeight={() => 'auto'}
              sx={{
                '& .MuiDataGrid-cell': {
                border: 1,
                borderRight: 0,
                borderTop: 0,
                borderColor: 'lightgrey',
                display: 'flex',
                alignItems: 'center',
                // justifyContent: 'center',
                },
                '& .MuiDataGrid-columnHeaders': {
                  borderBottom: '2px solid rgba(224, 224, 224, 1)',
                  borderTop: '2px solid rgba(224, 224, 224, 1)',
                  fontWeight: 600,
                  fontSize: '0.75rem',
                  p:0,
                  height: 'fit-content',
                  minHeight:'0 !important',
                  height:'2rem'
                },
                '& .MuiDataGrid-columnHeader': {
                borderLeft: '1px solid rgba(224, 224, 224, 1)',
                '&:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnHeaderTitle': {
                fontWeight: 600,
                color: '#3e3e3e'
                },
                '& .MuiDataGrid-row': {
                '&:last-child .MuiDataGrid-cell': {
                    borderBottom: '1px solid rgba(224, 224, 224, 1)',
                },
                '& .MuiDataGrid-cell:last-child': {
                    borderRight: 'none',
                },
                },
                '& .MuiDataGrid-columnSeparator': {
                display: 'none',
                },
            }}
            />
          </Box>
        </Box>
      </Card>
    </Box>
  )
}

export default CampaignList